import { APP_INITIALIZER, LOCALE_ID, NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChartsModule } from 'ng2-charts';
import { ApiService } from './api.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppService } from './app.service';
import { AuthInterceptor } from './shared/auth/auth.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import localeFr from '@angular/common/locales/fr';
import {registerLocaleData} from "@angular/common";
import { WorkflowComponentsModule } from './shared/workflow-components/workflow-components.module';
import { GlobalErrorHandler } from './shared/errors/global-error-handler';
import { CoreApiModule } from './core-api/core-api.module';
import { PlatformServiceProvider } from './core-api/platform/platform.service.provider';
import { CustomLoaderModule } from './shared/custom-loader/custom-loader.module';
import { MaterialModule } from './shared/material.module';
import { SynchronisationService } from './synchronisation.service';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalNotificationsService } from './shared/global-notifications.service';

registerLocaleData(localeFr);

export function initApp(_appService: AppService, _apiService: ApiService) {
    return () => new Promise<void>((resolve, reject) => {
      Promise.all([
        _appService.getAppVersion(),
      ]).then(() => {
        console.log("ABWORKFLOW LOADED");
        resolve();
      }, (errors) => { 
        if (window.document.getElementById('loading-spinner') !== null) {
          window.document.getElementById('loading-spinner').style.display = 'none';
        }
        if (window.document.getElementById('loading-error') !== null) {
          window.document.getElementById('loading-error').style.display = 'block';
        }
        console.log("FAILED TO LOAD ABWORKFLOW");
        reject(errors);
      });
    });
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule, 
    ChartsModule, 
    HttpClientModule, 
    BrowserAnimationsModule,
    WorkflowComponentsModule,
    CoreApiModule,
    CustomLoaderModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    LabelModule,
    DropDownsModule,
    DateInputsModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    ApiService,
    AppService,
    PlatformServiceProvider,
    SynchronisationService,
    GlobalNotificationsService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    //{ provide: ErrorHandler, useClass: GlobalErrorHandler }, 
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    { provide : APP_INITIALIZER, multi : true, deps : [AppService, ApiService], useFactory : initApp},
    { provide: LOCALE_ID, useValue: 'fr-FR'},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
